export default "__VITE_ASSET__d9f6b906__"